import BaseRepository from '@/api/repositories/BaseRepository';

export default class StatisticsRepository extends BaseRepository {
	getOverview(days, activeSince) {
		return this.get('statistics', '', {
			days: days,
			active_since: activeSince,
		});
	}

	getForFilter(months, activeSince, data, companyID = null) {
		return this.post('statistics/filter', { new_months: months, active_since: activeSince, company_id: companyID }, data);
	}

	showStatistics(params) {
		return this.get(`statistics-filter`, params);
	}
}
